import React, { useState } from 'react';
import { useTranslation } from 'next-i18next';

import TitleLink from '../../../components/TitleLink';
import { IDirector, IDoc } from '../../../api/investorApi';

import InvestorBlock from '../InvestorBlock';
import ContentList from '../ContentList';
import InfoCard from '../InfoCard';
import { OverallPdfCard } from '../PdfCard';
import DetailModal from '../DetailModal';

interface IProps {
  title: string;
  anchor: string;
  data: {
    directors: IDirector[];
    docs: IDoc[];
  };
}

function Governance(props: IProps) {
  const { title, anchor, data } = props;
  const { directors, docs } = data;
  const [currDirector, setCurrDirector] = useState<IDirector>();
  const [showDetail, setShowDetail] = useState<boolean>(false);
  const { t } = useTranslation('investor');

  const handleDirectorClick = (director: IDirector) => {
    setCurrDirector(director);
    setShowDetail(true);
  };

  const handleCloseModal = () => {
    setShowDetail(false);
  };

  return (
    <>
      <InvestorBlock title={title} anchor={anchor}>
        <TitleLink
          className="pb-[16px] lg:pb-[24px]"
          title={() => (
            <div className="flex w-full items-center justify-between">
              <h2 className="text-sm font-medium leading-none lg:text-lg">{t('titleDirectors')}</h2>
              <span className="text-sm leading-7 text-black-85">{t('latestUpdate')}</span>
            </div>
          )}
        />
        <ContentList>
          {directors?.map((director) => {
            return (
              <InfoCard
                key={director.name}
                title={director.name}
                desc={director.title}
                onClick={() => handleDirectorClick(director)}
              />
            );
          })}
        </ContentList>
        <TitleLink
          className="pb-[16px] pt-[20px] lg:pb-[24px] lg:pt-[40px] "
          title={() => <h2 className="text-sm font-medium leading-none lg:text-lg">{t('titleGovFiles')}</h2>}
          linkVal={t('titleSeeAll')}
          linkUrl="/investor/gov-files"
          linkOut
        />
        <ContentList smHideLast>
          {docs?.map((doc) => {
            return <OverallPdfCard key={doc.id} title={doc.title} date={doc.date} link={doc.link} />;
          })}
        </ContentList>
      </InvestorBlock>

      <DetailModal {...(currDirector || {})} visible={showDetail} onClose={handleCloseModal} />
    </>
  );
}

export { Governance };
